<script setup lang="ts">
import { UIContentWrap } from "@gohighlevel/ghl-ui";
import Postmate from "postmate";
import { ref } from "vue";
import { i18n } from "./plugin/vue-i18n";
import { useAppStore } from "./store/app";
import { setupPendo } from "./util/pendoConfig";
import { setSentryMeta } from "./util/setupSentry";
import { initRemoteApps } from "@/config/remoteApps";

initRemoteApps();
const appStore = useAppStore();

if (process.env.NODE_ENV === "development") {
  Postmate.debug = true;
}

const locale = ref("en-US");
const handshake = new Postmate.Model({
  updatedToken: (token: string) => appStore.refreshToken(token),
  customFieldAdd: (customAdded: boolean) => appStore.getCustomFields(),
  updateResultTemplate: (template: object) => appStore.updateResultTemplate(template),
  previewUrl: (previewData: string) => appStore.setPreviewUrl(previewData),
  sendIntegrateInfo: (integrate: object) => appStore.setIntegrateInfo(integrate),
  back: () => appStore.back(),
});

handshake.then(async ({ model }: any) => {
  appStore.initialize(model);
  await appStore.getPaymentIntegrationDetails();
  appStore.setAppHandshake(handshake);
  if (model.quizId) {
    await appStore.getQuiz();
  } else {
    await appStore.getFormOrSurvey();
  }
  appStore.getIntegrateInfo();
  appStore.getCustomFields();
  appStore.getCustomFieldFolders();
  appStore.getCustomObjects();
  appStore.getPipelines();
  await appStore.getCustomValues();
  appStore.getPreviewUrl();
  appStore.getAllFonts();
  await appStore.getThemeList();
  if (model.formId || model.surveyId) {
    await appStore.getProductStoredInForms();
    await appStore.getProductList();
  }

  i18n.global.locale.value = model.locale ?? "en-US";
  locale.value = model.locale;
  localStorage.setItem("locale", model.locale);
  setSentryMeta({
    userId: appStore.userId,
    companyId: appStore.company.id,
    locationId: appStore.locationId,
    email: appStore.email,
    locale: model.locale,
  });
  setupPendo(model);
});
</script>

<template>
  <UIContentWrap :full-screen="true" :locale="(locale as any)">
    <router-view></router-view>
  </UIContentWrap>
</template>
